import ApiGetOptions from '@/datatypes/api-get-options';
import ApiPostOptions from '@/datatypes/api-post-options';
import ApiPutOptions from '@/datatypes/api-put-options';
import ApiService from '@/services/api/ApiService';
import decamelizeKeysDeep from 'decamelize-keys-deep';

export default class BillingProductService extends ApiService {
  public create(params) {
    return this.call(new ApiPostOptions(
      {
        url: '/billing_products',
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public list(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/billing_products',
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public listProvider(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/billing_provider_products',
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public searchProvider(params) {
    return this.call(new ApiGetOptions(
      {
        url: '/billing_provider_products/search',
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public update(productId, params) {
    return this.call(new ApiPutOptions(
      {
        url: `/billing_products/${productId}`,
        data: decamelizeKeysDeep(params),
      },
    ));
  }

  public listProviderPrices(productId, params) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_provider_products/${productId}/billing_prices`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public show(billingProductId, params = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_products/${billingProductId}`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public showProvider(billingProductId, params = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_provider_products/${billingProductId}`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }

  public listPrices(billingProductId, params = {}) {
    return this.call(new ApiGetOptions(
      {
        url: `/billing_products/${billingProductId}/billing_prices`,
        params: decamelizeKeysDeep(params),
      },
    ));
  }
}
